export default {
  title: 'ExpertOrder',
  form: {
    api_key: {
      label: 'API-avain',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    error: 'Muutosten tallentaminen epäonnistui',
    success: 'Muutokset tallennettiin',
  },
  connected: {
    title: 'ExpertOrder on yhdistetty',
    description: 'Tämä integraatio on määritetty.',
  },
};
